import useAdministrationUsersColumns from './useAdministrationUsersColumns'

export default useAdministrationUsersColumns
